import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_PROCESSOS_ARRECADACAO = `${modulo.ARRECADACAO}/processos`

const actions = {
  async findById ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_PROCESSOS_ARRECADACAO}?id=${id}`,
      error: true
    })

    return data
  },

  async deleteById ({ commit }, processoId) {
    const data = await axios({
      method: 'DELETE',
      url: `${URL_PROCESSOS_ARRECADACAO}/deleteById?processoId=${processoId}`
    })

    return data
  },

  async findByIdCompleto ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_PROCESSOS_ARRECADACAO}?id=${id}&isCompleto=${true}`,
      error: true
    })

    return data
  },

  async tarefa ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `${URL_PROCESSOS_ARRECADACAO}/tarefa/${dados.processo}`
    })
    return data
  },

  async tramitarValidacao ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitarValidacao/${id}`
    })
    return data
  },

  async tramitarRevisao ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitarRevisao/${id}`
    })
    return data
  },

  async tramitarAnalisar ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitarAnalisar/${id}`
    })
    return data
  },

  async tramitar ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitar/${dados.processo}`
    })
    return data
  },

  async tramitarComAcao ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitarComAcao`,
      data: dados
    })
    return data
  },

  async iniciarAnalise ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `${URL_PROCESSOS_ARRECADACAO}/iniciarAnalise`,
      data: dados
    })
    return data
  },

  async saveStep ({ commit }, { url, dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url,
      error: true
    })

    return data
  },

  async find ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/findByFilter`,
      data: filtro
    })
    return data
  },

  async findAllByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/findAllByFilter`,
      data: filtro,
      loader: false
    })
    return data
  },

  saveDadosDiarioOficial ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/saveDadosDiarioOficial`,
      data: dados
    })
  },

  finalizarDiarioOficial ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/finalizarDiarioOficial`,
      data: dados,
      error: true
    })
  },

  saveArquivamento ({ commit }, { id, dados }) {
    return axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/saveArquivamento?id=${id}`,
      data: dados
    })
  },

  finalizarArquivamento ({ commit }, { id, dados }) {
    return axios({
      method: 'post',
      url: `${URL_PROCESSOS_ARRECADACAO}/finalizarArquivamento?id=${id}`,
      data: dados
    })
  },
  async tramitarComAssinatura ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `${URL_PROCESSOS_ARRECADACAO}/tramitarComAssinatura`,
      data: dados
    })
    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/processoArrecadacao.js